import { useEffect, useState } from "react";

const getDeviceType = () => {
  const tabletSizes = { min: 767, max: 1023 };
  const width = window.innerWidth;

  if (width <= tabletSizes.min) return "mobile";
  if (width <= tabletSizes.max) return "tablet";
  return "desktop";
};

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType());
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return deviceType;
};

export const useIsDeviceMobile = () => {
  const deviceType = useDeviceType();
  return deviceType === "mobile";
};

export default useDeviceType;
